import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=b3808de2&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=b3808de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3808de2",
  null
  
)

export default component.exports